var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAvatar2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 117,
    viewBox: "0 0 103 117",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 43.7625,
    y: 14.5873,
    width: 14.5875,
    height: 14.5875,
    rx: 7.29373,
    fill: "#97EF89"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 43.7625,
    y: 29.175,
    width: 14.5875,
    height: 14.5875,
    rx: 7.29373,
    fill: "#97EF89"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 43.7625,
    y: 43.7623,
    width: 14.5875,
    height: 14.5875,
    rx: 7.29373,
    fill: "#97EF89"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 58.3497,
    y: 87.5245,
    width: 14.5875,
    height: 14.5875,
    rx: 7.29373,
    fill: "#97EF89"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 58.3497,
    y: 14.5873,
    width: 14.5875,
    height: 14.5875,
    rx: 7.29373,
    fill: "#97EF89"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 58.3497,
    y: 43.7623,
    width: 14.5875,
    height: 14.5875,
    rx: 7.29373,
    fill: "#97EF89"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 14.5875,
    y: 72.9369,
    width: 14.5875,
    height: 14.5875,
    rx: 7.29373,
    fill: "#97EF89"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 72.9373,
    y: 58.3496,
    width: 14.5875,
    height: 14.5875,
    rx: 7.29373,
    fill: "#97EF89"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 87.5248,
    y: 72.9369,
    width: 14.5875,
    height: 14.5875,
    rx: 7.29373,
    fill: "#97EF89"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 14.5875,
    y: 43.7623,
    width: 14.5875,
    height: 14.5875,
    rx: 7.29373,
    fill: "#97EF89"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 29.1749,
    y: 29.175,
    width: 14.5875,
    height: 14.5875,
    rx: 7.29373,
    fill: "#97EF89"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 29.1749,
    y: 58.3496,
    width: 14.5875,
    height: 14.5875,
    rx: 7.29373,
    fill: "#97EF89"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 43.7625,
    y: 87.5244,
    width: 14.5875,
    height: 14.5875,
    rx: 7.29373,
    fill: "#97EF89"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 14.5875,
    y: 58.3496,
    width: 14.5875,
    height: 14.5875,
    rx: 7.29373,
    fill: "#97EF89"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 43.7625,
    width: 14.5875,
    height: 14.5875,
    rx: 7.29373,
    fill: "#97EF89"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 43.7625,
    y: 58.3496,
    width: 14.5875,
    height: 14.5875,
    rx: 7.29373,
    fill: "#97EF89"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 43.7625,
    y: 72.9369,
    width: 14.5875,
    height: 14.5875,
    rx: 7.29373,
    fill: "#97EF89"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 58.3497,
    y: 72.9369,
    width: 14.5875,
    height: 14.5875,
    rx: 7.29373,
    fill: "#97EF89"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 72.9373,
    y: 43.7623,
    width: 14.5875,
    height: 14.5875,
    rx: 7.29373,
    fill: "#97EF89"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 58.3497,
    y: 29.175,
    width: 14.5875,
    height: 14.5875,
    rx: 7.29373,
    fill: "#97EF89"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 58.3497,
    y: 58.3496,
    width: 14.5875,
    height: 14.5875,
    rx: 7.29373,
    fill: "#97EF89"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 29.1749,
    y: 87.5245,
    width: 14.5875,
    height: 14.5875,
    rx: 7.29373,
    fill: "#97EF89"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 72.9373,
    y: 72.9369,
    width: 14.5875,
    height: 14.5875,
    rx: 7.29373,
    fill: "#97EF89"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 29.1749,
    y: 14.5873,
    width: 14.5875,
    height: 14.5875,
    rx: 7.29373,
    fill: "#97EF89"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 29.1749,
    y: 43.7623,
    width: 14.5875,
    height: 14.5875,
    rx: 7.29373,
    fill: "#97EF89"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 29.1749,
    y: 72.9369,
    width: 14.5875,
    height: 14.5875,
    rx: 7.29373,
    fill: "#97EF89"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 43.7625,
    y: 102,
    width: 14.5875,
    height: 14.5875,
    rx: 7.29373,
    fill: "#97EF89"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    y: 72.9369,
    width: 14.5875,
    height: 14.5875,
    rx: 7.29373,
    fill: "#97EF89"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar2);
export default __webpack_public_path__ + "static/media/avatar2.ca67cbda0be838127c2c907f5a94053e.svg";
export { ForwardRef as ReactComponent };